<script>
  import { onMount } from 'svelte';
  import {summaryURL} from './settings';
    import FullBar from './FullBar.svelte';
  let loading = true;
  let error = false;
  let first = null;
  let last = null;
  let count = 0;
  let chartData = [];

  onMount(async () => {
    try {
      const response = await fetch(summaryURL);
      const content = await response.json();
      if (content.error) {
        console.warn(content.error);
        loading = false;
        error = true;
      } else {
        let format1 = { day: 'numeric', month: 'long'}
        if (new Date(content.data.first).getFullYear() != new Date(content.data.last).getFullYear()) {
          format1 = { day: 'numeric', month: 'long', year: 'numeric' };
        }
        first = new Intl.DateTimeFormat('it-IT', format1).format(new Date(content.data.first));
        last = new Intl.DateTimeFormat('it-IT', { day: 'numeric', month: 'long', year: 'numeric'}).format(new Date(content.data.last));
        count = new Intl.NumberFormat('it-IT', (content.data.count < 10000 ? {} : { notation: 'compact' })).format(content.data.count);

        const tmpData = [{
            val: content.data.positive,
            perc: content.data.positive / content.data.count * 100,
            class: 'positive',
            label: `Tono positivo: ${new Intl.NumberFormat('it-IT', { style: 'percent' }).format(content.data.positive / content.data.count)}`
          },
          {
            val: content.data.negative,
            perc: content.data.negative / content.data.count * 100,
            class: 'negative',
            label: `Tono negativo: ${new Intl.NumberFormat('it-IT', { style: 'percent' }).format(content.data.negative / content.data.count)}`
          },
          {
            val: content.data.neutral,
            perc: content.data.neutral / content.data.count * 100,
            class: 'neutral',
            label: `Tono neutro: ${new Intl.NumberFormat('it-IT', { style: 'percent' }).format(content.data.neutral / content.data.count)}`
          }
        ];
        tmpData.sort((a, b) => b.val - a.val);
        chartData = tmpData;
        loading = false;
      }
    } catch(e) {
      console.warn(e);
      loading = false;
      error = true;
    }
  })
</script>

<div id="summary"  class="{loading ? 'loading' : ''}">
  {#if error}
    <p class="error">C'è stato un problema nel caricamento dei dati, per favore riprova più tardi.</p>
  {:else}
    <div class="summary--content">
      <div class="summary--text">
        <p class="data">Tra il <strong>{first}</strong> e il <strong>{last}</strong> abbiamo analizzato i titoli di <strong>{count}</strong> news così suddivise per <strong>tono</strong> e per <strong>protagonista</strong>:</p>
      </div>
      <div class="summary--chart">
        <FullBar bars={chartData} />
      </div>
    </div>
  {/if}
</div>
<style>
  #summary {
    align-items: center;
    display: flex;
    height: auto;
    justify-content: center;
    margin: 0 20px;
    opacity: 1;
    padding: 25vh 0 0 0;
    transition: opacity .5s ease-in-out;
    width: auto;
  }

  #summary.loading {
    opacity: 0;
  }

  .summary--text {
    margin-bottom: 40px;
  }

  .summary--chart {
    display: block;
    width: 100%;
  }

  @media screen and (min-width: 768px) {
    #summary {
      max-width: 960px;
    }
  }

  @media screen and (min-width: 1024px) {
    #summary {
      margin: 0 auto;
    }
  }
</style>